import { render, staticRenderFns } from "./DurationSetting.vue?vue&type=template&id=96df8b88&"
import script from "./DurationSetting.vue?vue&type=script&lang=js&"
export * from "./DurationSetting.vue?vue&type=script&lang=js&"
import style0 from "./DurationSetting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports